import * as React from 'react';
import { connect } from 'react-redux';
import NewSettingPopup from '../common/NewSettingPopup';
import SettingPopupTabs from '../common/setting-popup-tabs/SettingPopupTabs';
import SettingPopupTabList from '../common/setting-popup-tabs/SettingPopupTabList';
import SettingPopupTab from '../common/setting-popup-tabs/SettingPopupTab';
import SettingPopupTabPanel from '../common/setting-popup-tabs/SettingPopupTabPanel';
import ToolIconButton from '../common/ToolIconButton';
import UIAction from '../../actions/ui/UIAction';
import { Dispatch, Action } from 'redux';
import { CurrentTool, MultiroleLinkState } from '../../reducers/ui/ui';
import { AppStates } from '../../reducers/app';
import MultiroleLinkFileTabPanel from './MultiroleLinkFileTabPanel';
import MultiroleLinkWebTabPanel from './MultiroleLinkWebTabPanel';
import MultiroleLinkPageTabPanel from './MultiroleLinkPageTabPanel';
import { MultiroleLinkKind } from '../../../../../common/src/ts/types/multiroleLink';

interface NewMultiroleLinkDialogProps {
  readonly multiroleLink: MultiroleLinkState;
  readonly onClose: () => void;
  readonly dispatch: Dispatch<Action>;
}

const tabStyle: React.CSSProperties = {
  width: 'auto',
  paddingLeft: '1em',
  paddingRight: '1em',
};

interface NewMultiroleLinkDialogState extends MultiroleLinkState {
  readonly setState: (state: Partial<MultiroleLinkState>) => void;
}

export const NewMultiroleLinkDialogContext = React.createContext<NewMultiroleLinkDialogState>({
  mode: MultiroleLinkKind.File,
  [MultiroleLinkKind.File]: {
    path: '',
    title: '',
    pinColor: '1',
  },
  [MultiroleLinkKind.Web]: {
    url: '',
    title: '',
    pinColor: '1',
  },
  [MultiroleLinkKind.Page]: {
    pageKey: '',
    title: '',
    pinColor: '1',
  },
  setState: () => {},
});

const tabIndex = {
  [MultiroleLinkKind.File]: 0,
  [MultiroleLinkKind.Web]: 1,
  [MultiroleLinkKind.Page]: 2,
};

class NewMultiroleLinkDialog extends React.PureComponent<
  NewMultiroleLinkDialogProps,
  NewMultiroleLinkDialogState
> {
  public constructor(props: NewMultiroleLinkDialogProps) {
    super(props);

    this.state = {
      ...this.props.multiroleLink,
      setState: (this.setState as (state: Partial<MultiroleLinkState>) => void).bind(this),
    };
  }

  private handleOKClick = () => {
    const { onClose, dispatch } = this.props;
    const {
      mode,
      [MultiroleLinkKind.File]: file,
      [MultiroleLinkKind.Web]: web,
      [MultiroleLinkKind.Page]: page,
    } = this.state;

    UIAction.setCurrentTool(CurrentTool.MultiroleLink, dispatch);
    UIAction.setMultiroleLinkState(
      {
        mode,
        [MultiroleLinkKind.File]: file,
        [MultiroleLinkKind.Web]: web,
        [MultiroleLinkKind.Page]: page,
      },
      dispatch,
    );
    onClose();
  }

  public render() {
    const { onClose } = this.props;

    return (
      <NewSettingPopup title="マイリンク" onClose={onClose}>
        <NewMultiroleLinkDialogContext.Provider value={this.state}>
          <SettingPopupTabs initialSelectedTabIndex={tabIndex[this.state.mode]}>
            <SettingPopupTabList>
              <SettingPopupTab
                style={tabStyle}
                onClick={() => { this.setState({ mode: MultiroleLinkKind.File }); }}>
                ファイルの選択
              </SettingPopupTab>
              <SettingPopupTab
                style={tabStyle}
                onClick={() => { this.setState({ mode: MultiroleLinkKind.Web }); }}>
                ウェブの選択
              </SettingPopupTab>
              <SettingPopupTab
                style={tabStyle}
                onClick={() => { this.setState({ mode: MultiroleLinkKind.Page }); }}>
                ページの選択
              </SettingPopupTab>
            </SettingPopupTabList>
            <SettingPopupTabPanel style={{ height: '100%' }}>
              <MultiroleLinkFileTabPanel />
              <MultiroleLinkWebTabPanel />
              <MultiroleLinkPageTabPanel />
            </SettingPopupTabPanel>
          </SettingPopupTabs>
        </NewMultiroleLinkDialogContext.Provider>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <ToolIconButton text="キャンセル" onClick={onClose} />
          <ToolIconButton text="OK" onClick={this.handleOKClick} />
        </div>
      </NewSettingPopup>
    );
  }
}

const mapStateToProps = (appStates: AppStates) => (
  { multiroleLink: appStates.ui.multiroleLink }
);

export default connect(mapStateToProps)(NewMultiroleLinkDialog);
